import { atom } from 'jotai';
import { staticDataAtom } from 'Atoms/Common';
import {
  getTicketOrder,
  getTicketAliasFromPathname,
  getPayPlusData,
} from 'utils';

export const displayShareTicketAtom = atom(false);
export const displayListContentAtom = atom(false);

export const stepPaymentTicketAtom = atom('selected');

export const paymentPendingValidationAtom = atom(false);

export const tipsAtom = atom(0);
export const activePersonalizedTipsAtom = atom(false);

export const feedbackCookingAtom = atom(0);
export const feedbackServiceAtom = atom(0);

export const payPlusSessionAtom = atom({
  idTransaction: null,
  session: null,
  token: null,
});

export const isIOSDeviceAtom = atom(() => {
  if (navigator?.userAgent?.toLowerCase()?.includes('iphone')) {
    return true;
  } else {
    return false;
  }
});

/* export const ticketAtom = atom({
  order: {
    date: null,
    id: null,
    totals: {
      amount: null,
    },
    discount: {},
    sections: [],
    payments: [],
    nbGuests: 0,
    table: {
      name: null,
      id: null,
    },
    taxes: {
      id: null,
      evat: null,
      label: null,
      tax: null,
    },
  },
}); */
export const ticketAtom = atom(async (get) => {
  const pathname = window?.location?.pathname;
  const ticketAlias = getTicketAliasFromPathname(pathname);
  const initTicket = {
    order: {
      date: null,
      id: ticketAlias,
      totals: {
        amount: null,
      },
      sections: [],
      payments: [],
      nbGuests: 0,
      table: {
        name: null,
        id: null,
      },
      taxes: {
        id: null,
        evat: null,
        label: null,
        tax: null,
      },
      enablePayment: false, // possibility to add tips only if the service is still open
    },
  };
  try {
    const ticketData = await getTicketOrder(ticketAlias, initTicket);
    return ticketData;
  } catch (e) {
    console.log(e);
    return e;
  }
});

export const urlTicketAtom = atom((get) => {
  const { url } = get(ticketAtom);
  return url;
});

export const shareNoteAtom = atom({
  selected: '',
  value: null,
  condition: null,
});

export const amountToPayPerProductAtom = atom(0);

export const amountToPayAtom = atom((get) => {
  const { order } = get(ticketAtom);
  const total = order?.totals?.amount;
  const { selected, value, condition } = get(shareNoteAtom); // si selected -> null renvoyer total du reste à payer

  switch (selected) {
    case 'perPeople':
      const newTotal = total / value;
      return newTotal > 0.1 ? newTotal : 0;
    case 'perAmount':
      return value;
    case 'perProduct':
      const totalAmountProduct = calculAmountTotalProductsSections(value)
      const totalFormatted = Math.round(total * 1000) / 1000
      return totalAmountProduct <= totalFormatted ? totalAmountProduct : totalFormatted
    default:
      return total;
  }
});

export const listProductsSelectedToPayAtom = atom([]);

export const listProductsToPayAtom = atom((get) => {
  const { order } = get(ticketAtom);
  const { sections } = order;

  const sectionsToPay = sections.reduce((acc, curr) => {
    const productsToPay = [];

    curr.lines.map((line, i) => {
      let count = line.nb;
      return Array.apply(null, new Array(line.nb)).map(() => {
        if (count > line.paid) {
          productsToPay.push({
            ...{ ...line, idSection: curr.id },
            nb: 1,
            uiId: count,
          });
        }
        count--;
      });
    });

    return {
      id: curr.id,
      name: curr.name,
      lines: productsToPay,
    };
  }, []);

  return [sectionsToPay];
});

const calculRestToPayAfterRemovePaymentsAlreadyMade = (total, payments) => {
  return payments.reduce((acc, curr) => {
    return curr && curr.amount ? acc - curr.amount : acc;
  }, total);
};

// TODO Test unit
/**
 * calcul total amount from arrayProduct
 * @param {array} arrayProduct
 * @param {string} condition
 * @returns number
 */
const calculAmountTotalProductsSections = (arrayProduct) => {
  if(!arrayProduct || !arrayProduct.length) return 0

  return arrayProduct.reduce((price, prod) => {
    let extra = (prod.sublines || []).reduce((priceSub, sub) =>  priceSub + sub.price, 0)
    return price + prod.price + extra
  }, 0);
};

export const goToPayAtom = atom(false);
